export default function Footer() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <span className="font-heading text-2xl text-primary-400 tracking-wide">
              汗汗漫画
            </span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              汗汗漫画主打下拉式漫画连续阅读，滚动观看不间断，漫画下拉即可加载全集，免费流畅观看各类漫画，感受全新阅读方式。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#hero');
                }}
                className="text-background-100 hover:text-primary-400 transition-colors no-underline"
              >
                快速导航
              </a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { href: '#media', label: '精彩视频' },
                { href: '#carousel', label: '焦点专题' },
                { href: '#updates', label: '更新快讯' },
                { href: '#ranking', label: '热门榜单' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#faq');
                }}
                className="text-background-100 hover:text-primary-400 transition-colors no-underline"
              >
                帮助中心
              </a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { href: '#faq', label: '常见问题' },
                { href: '#contact', label: '联系我们' },
                { href: '#app', label: 'APP下载' },
                { href: '#features', label: '平台特色' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 汗汗漫画 · 下拉式漫画连续阅读滚动观看
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('#hero');
              }}
              className="text-xs text-background-500 hover:text-primary-400 transition-colors no-underline"
            >
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}